import React from "react";
import { DotLegalCheckbox, DotLegalDialog, DotLegalHeader, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useCreateSavedViewHook } from "./CreateSavedViewDialog.hooks";
import { FilterPage } from "../../../pageView/PageView.types.ts";
import { useTranslation } from "../../../../localization/useTranslation.ts";
import { Box } from "@mui/material";
import { useUserContext } from "../../../../auth/userContextProvider/UserContextProvider.tsx";

export interface CreateSavedViewDialogProps {
    onClose: () => void;
    onViewSaved: (viewId: string) => void;
    filterConfiguration: any;
    displayConfiguration: any;
    savedViewType: FilterPage;
    scopeId?: string;
    secondaryScopeId?: string;
}

function CreateSavedViewDialog(props: CreateSavedViewDialogProps) {
    const { translateString } = useTranslation();
    const { permissions } = useUserContext();

    const { saveModel, updater, showError, onCreateView, inProgress } = useCreateSavedViewHook(props);

    return (
        <DotLegalDialog
            open
            onDialogClose={props.onClose}
            header={translateString("createNewView")}
            buttonOkText={translateString("save")}
            onOkClick={onCreateView}
            size={"sm"}
            inProgress={inProgress}
        >
            <DotLegalHeader headerStyle={"small"} fontWeight={400} marginTop={-2} center marginBottom={3}>
                {translateString("saveViewInfoText")}
            </DotLegalHeader>

            <DotLegalTextField
                label={translateString("viewName")}
                value={saveModel.name}
                onChange={updater.onNameChange}
                placeholder={translateString("viewName")}
                autoFocus
                debounce={false}
                errorText={showError ? translateString("nameRequired") : undefined}
            />

            {permissions.contractManagementPermissions.canManageGlobalViews && (
                <Box sx={{ marginLeft: "-12px", display: "flex", flexDirection: "column" }}>
                    <DotLegalCheckbox
                        tooltip={translateString("saveViewAsGlobalToolTipText")}
                        label={translateString("saveAsGlobalView")}
                        checked={saveModel.isGlobal}
                        onChange={updater.onIsGlobalChange}
                        disabled={saveModel.isCustomerDefault}
                    />

                    <DotLegalCheckbox
                        tooltip={translateString("saveViewAsCustomerStandardTooltip")}
                        label={translateString("setAsOrganisationDefaultView")}
                        checked={saveModel.isCustomerDefault}
                        onChange={updater.onIsCustomerDefaultChange}
                    />
                </Box>
            )}
        </DotLegalDialog>
    );
}

export default CreateSavedViewDialog;
